import React, { Fragment } from "react";
import { Link, Redirect } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import StarRatings from "react-star-ratings";
// Redux
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { login, auth } from "../../actions/auth";
import { validateCoupon } from "../../actions/coupon";
import { shipmentAdd } from "../../actions/shipment";
import { getCart } from "../../actions/cart";
import { payNow, payWithAffirm } from "../../actions/payment";
import { getAddressBook } from "../../actions/addressbook";
import { validateEasypost } from "../../actions/easypost";
//components
import BreadCrumb from "../../components/breadcrumb/breadcrumb";
import { getShipment } from "../../actions/shipment";
import Alert from "../../components/alert/alert.component";

class Checkout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cart: [],
      total: 0,
      coupon: "",
      couponObject: "",
      couponValidMsg: null,
      address: null,
      choosedBillAddress: null,
      choosedShipAddress: null,
      cardNumber: "",
      cardholderName: "",
      cvc: "",
      exp: 10,
      year: 20,
      addressClass: "current",
      deliveryClass: "current",
      cardClass: "disabled",
      successClass: "disabled",
      paymentMethod: "",
      addressClassShow: "show",
      cardClassShow: "hide",
      successClassShow: "hide",
      deliveryClassShow: "hide",
      texjar: "",
      texjarObject: "",
      texjarMessage: null,
      texjarSales: "",
      shipment: 0,
      easypost: [],
      affirmEmpty: true,
      easypostObj: "",
      easypostObjs: [],
      easypostTex: 0,
      affirmCheckout: true,
      rewardPoints: 0,
      cartSummary: false,
    };
  }
  handleSummary = () => {
    this.setState({
      cartSummary: !this.state.cartSummary,
    });
  };
  async componentDidMount() {
    const _res = await this.props.getAddressBook();
    if (_res) {
      this.setState({ address: _res });
    }
    const { user } = this.props._auth;
    if (user && user.rewardPoints && user.rewardPoints !== 0) {
      this.setState({ rewardPoints: user.rewardPoints });
    }
    const res = await this.props.getCart();
    this.setState({ cart: res });
    if (res && res.length === 0) {
      this.props.history.push("/");
    }
    const priceArr = [];

    res &&
      res.forEach((element) => {
        priceArr.push(
          element.color && element.color
            ? element.item.enableSale === true
              ? Number(element.colorPrice) * element.quantity -
                (Number(element.colorPrice) * element.item.saleDiscount) / 100
              : Number(element.colorPrice) * element.quantity
            : element.item.enableSale === true
            ? element.item.price * element.quantity -
              (element.item.price * element.item.saleDiscount) / 100
            : element.item.price * element.quantity
        );
      });

    var total = 0;
    for (var i in priceArr) {
      total += priceArr[i];
    }
    if (total < 49) {
      this.setState({ shipment: 4.99 });
    }
    setInterval(async () => {
      const shipm = await this.props.getShipment();
      this.setState({ easypost: shipm });
      var ship = 0;
      if (localStorage.getItem("shipment") !== null) {
        if (
          Object.keys(JSON.parse(localStorage.getItem("shipment"))).length !== 0
        ) {
          const shipment = JSON.parse(localStorage.getItem("shipment"));
          shipment.forEach((element) => {
            ship += Number(element.selectedShipping.rate);
          });
          if (total < 49 && ship === 0) {
            this.setState({ shipment: 4.99 });
          } else {
            this.setState({ shipment: ship });
          }
        }
      }
    }, 1000);

    this.setState({ total: parseFloat(total).toFixed(2) });

    if (!res) {
      this.setState({ cart: [] });
    }
    if (localStorage.getItem("zipcode") !== null) {
      if (
        Object.keys(JSON.parse(localStorage.getItem("zipcode"))).length !== 0
      ) {
        var texObj = JSON.parse(localStorage.getItem("zipcode"));
        this.setState({
          texjarObject: texObj,
        });
        this.setState({
          texjarSales: texObj.rate.combined_rate
            ? Number(texObj.rate.combined_rate) * 100
            : 0,
        });
      }
    }
    if (localStorage.getItem("coupon") !== null) {
      if (
        Object.keys(JSON.parse(localStorage.getItem("coupon"))).length !== 0
      ) {
        var couponObj = JSON.parse(localStorage.getItem("coupon"));
        this.setState({
          couponObject: couponObj,
        });
      }
    }
    if (this.state.affirmEmpty) {
      localStorage.setItem("affirm", JSON.stringify([]));
      localStorage.setItem("shipment", JSON.stringify([]));
      this.setState({ affirmEmpty: false });
    }
    this._easypost();
  }

  async componentWillMount() {
    setInterval(async () => {
      if (localStorage.getItem("affirm") !== null) {
        if (
          Object.keys(JSON.parse(localStorage.getItem("affirm"))).length !== 0
        ) {
          var affirm = JSON.parse(localStorage.getItem("affirm"));

          if (this.state.affirmCheckout) {
            this.setState({ affirmCheckout: false });
            this.saveAffirmDetails(affirm.checkout_token);
          }
        }
      }
    }, 1500);
  }

  cartBlukHandler = async () => {
    const data = {
      cardNumber: "4242424242424242",
      expirationDate: "0822",
      cardCode: "999",
      amount: this.state.total,
      items: this.state.cart,
      bill: this.state.choosedBillAddress,
      ship: this.state.choosedShipAddress,
    };
    const res = await this.props.payNow(data);
  };

  removeCartItem = (index) => {
    const cartArr = JSON.parse(localStorage.getItem("cart"));
    cartArr.splice(index, 1);
    localStorage.setItem("cart", JSON.stringify(cartArr));
  };

  decreaseCartQuantity = (index) => {
    const cartArray = JSON.parse(localStorage.getItem("cart"));
    if (cartArray[index].quantity > 1) {
      cartArray[index].quantity = cartArray[index].quantity - 1;
      localStorage.setItem("cart", JSON.stringify(cartArray));
      window.location.reload();
    }
  };
  increaseCartQuantity = (index) => {
    const cartArray = JSON.parse(localStorage.getItem("cart"));
    cartArray[index].quantity = cartArray[index].quantity + 1;
    localStorage.setItem("cart", JSON.stringify(cartArray));
    window.location.reload();
  };
  _addToWishlist = async (item) => {
    const wishlistData = localStorage.getItem("wishlist");
    if (wishlistData && wishlistData.length > 0) {
      const arr = JSON.parse(wishlistData);
      var a = true;
      arr.forEach((e, index) => {
        if (e._id === item._id) {
          a = false;
          arr.splice(index, 1);
          toast(`Product removed from wishlist`, { containerId: "B" });
        }
      });
      if (a === true) {
        arr.push(item);
      }
      localStorage.setItem("wishlist", JSON.stringify(arr));
    } else {
      localStorage.setItem("wishlist", JSON.stringify([item]));
    }
    if (a !== false) {
      toast(`Product added to wishlist`, { containerId: "B" });
    }
  };
  _validateCoupon = async () => {
    const res = await this.props.validateCoupon({ coupon: this.state.coupon });

    if (res.status === true) {
      this.setState({ couponObject: res, couponValidMsg: true });
      const discount = (
        (this.state.couponObject.coupon.pricePercentage / 100) *
        parseFloat(this.state.total)
      ).toFixed(2);
      this.setState({ total: parseFloat(this.state.total) - discount });
    } else if (res && res.status === false) {
      this.setState({ couponValidMsg: false });
    }
  };

  payNow = async () => {
    if (
      this.state.cardNumber !== "" &&
      this.state.cardholderName !== "" &&
      this.state.cvc !== ""
    ) {
      var total_price =
        this.state.total && this.state.couponObject
          ? Number(
              Number(this.state.total) -
                (this.state.couponObject.coupon.pricePercentage / 100) *
                  Number(this.state.total) +
                (this.state.texjarSales / 100) * this.state.total +
                this.state.shipment -
                this.state.rewardPoints
            ).toFixed(2)
          : Number(
              Number(this.state.total) +
                (this.state.texjarSales / 100) * this.state.total +
                this.state.shipment -
                this.state.rewardPoints
            ).toFixed(2);
      const data = {
        cardNumber: this.state.cardNumber,
        expirationDate: this.state.exp + this.state.year, //this.state.exp,
        cardCode: this.state.cvc,
        amount: parseFloat(total_price),
        items: this.state.cart,
        paymentMethod: "Authorize",
        easypost: this.state.easypost,
        rewardPoints: this.state.rewardPoints,
        texjar:
          this.state.texjarSales &&
          Number((this.state.texjarSales / 100) * this.state.total).toFixed(2),
        bill: {
          firstName: this.state.choosedBillAddress.firstName,
          lastName: this.state.choosedBillAddress.lastName,
          company: this.state.choosedBillAddress.company,
          address: this.state.choosedBillAddress.address,
          city: this.state.choosedBillAddress.city,
          state: this.state.choosedBillAddress.region,
          zip: this.state.choosedBillAddress.postCode,
          country: this.state.choosedBillAddress.country,
        },
        ship: {
          firstName: this.state.choosedShipAddress.firstName,
          lastName: this.state.choosedShipAddress.lastName,
          company: this.state.choosedShipAddress.company,
          address: this.state.choosedShipAddress.address,
          city: this.state.choosedShipAddress.city,
          state: this.state.choosedShipAddress.region,
          zip: this.state.choosedShipAddress.postCode,
          country: this.state.choosedShipAddress.country,
        },
      };
      const res = await this.props.payNow(data);

      if (res && res.response.messages.resultCode === "Ok") {
        this.setState({
          addressClass: "disabled done",
          cardClass: "disabled done",
          successClass: "current done",
          addressClassShow: "hide",
          cardClassShow: "hide",
          successClassShow: "show",
          total: 0,
          easypostTex: 0,
          shipment: 0,
          rewardPoints: 0,
        });
        localStorage.setItem("cart", JSON.stringify([]));
        localStorage.setItem("coupon", JSON.stringify([]));
        localStorage.setItem("shipment", JSON.stringify([]));
      } else {
        // toast.error(`${res.errors[0].msg}`, { containerId: "B" });
      }
    } else {
      toast.error(`Please Fill All the fields`, { containerId: "B" });
    }
  };
  payWithAffirm = async () => {
    const { user } = this.props._auth;
    const items = this.state.cart;
    var products_item = [];
    items.forEach((element) => {
      var obj = {};
      obj.display_name = element.item.title;
      obj.sku = element.item.sku ? element.item.sku : element.item.slug;
      obj.unit_price = element.item.price.toFixed(2);
      obj.qty = element.quantity;
      obj.item_image_url = element.item.images[0];
      obj.item_url = "/product/" + element.item.slug;
      products_item.push(obj);
    });

    var obje = JSON.stringify(products_item);
    var tex =
      this.state.texjarSales &&
      (this.state.texjarSales / 100) * this.state.total;
    var total_price =
      this.state.total && this.state.couponObject
        ? Number(
            Number(this.state.total) -
              (this.state.couponObject.coupon.pricePercentage / 100) *
                Number(this.state.total) +
              (this.state.texjarSales / 100) * this.state.total +
              this.state.shipment -
              this.state.rewardPoints
          )
        : Number(
            Number(this.state.total) +
              (this.state.texjarSales / 100) * this.state.total +
              this.state.shipment -
              this.state.rewardPoints
          );
    const s = document.createElement("script");
    s.type = "text/javascript";
    s.async = true;
    s.innerHTML = `affirm.checkout({
      "config": {
        "financial_product_key" : "WVH2HKSZQ62ZCBV6"
      },
      "merchant": {
        user_cancel_url: "https://www.affirm.com",
        user_confirmation_url: "https://www.affirm.com",
        user_confirmation_url_action: "GET",
      },
    
      //shipping contact
      "shipping": {
        "name": {
          "first" : "${this.state.choosedBillAddress.firstName}",
          "last" : "${this.state.choosedBillAddress.lastName}"
        },
        "address": {
          "line1"  : "${this.state.choosedShipAddress.address}",
          "line2"  : "",
          "city"   : "${this.state.choosedShipAddress.city}",
          "state"  : "${this.state.choosedShipAddress.region}",
          "zipcode": "${this.state.choosedBillAddress.postCode}"
        },
        "email"          : "${user.email}",
        "phone_number"   : "${user.phone}"
      },
      metadata: {
        mode: "modal",
      },
      // cart 
      "items": ${obje},
      "currency"        : "USD",
      "tax_amount"      : ${tex ? tex : 0},
      "shipping_amount" : ${this.state.shipment ? this.state.shipment : 0},
      "total"           : ${Number(total_price * 100).toFixed(0)}
    }); 
     $(document).ready(function () {
      $("#submit-form").click(function() {
        affirm.checkout.open({
          onFail: function(e) {
            console.log(e);
          },
          onSuccess: function(a) {
            localStorage.setItem('affirm',JSON.stringify(a))
            
            alert(
              "Affirm checkout successful checkout token is: " + a.checkout_token
            );
          }
        });
      });
  });`;
    document.body.appendChild(s);
  };
  saveAffirmDetails = async (transactionId) => {
    var total_price =
      this.state.total && this.state.couponObject
        ? Number(
            Number(this.state.total) -
              (this.state.couponObject.coupon.pricePercentage / 100) *
                Number(this.state.total) +
              (this.state.texjarSales / 100) * this.state.total +
              this.state.shipment -
              this.state.rewardPoints
          ).toFixed(2)
        : Number(
            Number(this.state.total) +
              (this.state.texjarSales / 100) * this.state.total +
              this.state.shipment -
              this.state.rewardPoints
          ).toFixed(2);
    const data = {
      amount: parseFloat(total_price),
      items: this.state.cart,
      easypost: this.state.easypost,
      paymentMethod: "affirm",
      paymentStatus: "installments",
      rewardPoints: this.state.rewardPoints,
      transactionId: transactionId,
      texjar:
        this.state.texjarSales &&
        Number((this.state.texjarSales / 100) * this.state.total).toFixed(2),
      billingDetail: {
        firstName: this.state.choosedBillAddress.firstName,
        lastName: this.state.choosedBillAddress.lastName,
        company: this.state.choosedBillAddress.company,
        address: this.state.choosedBillAddress.address,
        city: this.state.choosedBillAddress.city,
        state: this.state.choosedBillAddress.region,
        zip: this.state.choosedBillAddress.postCode,
        country: this.state.choosedBillAddress.country,
      },
      shippingDetail: {
        firstName: this.state.choosedShipAddress.firstName,
        lastName: this.state.choosedShipAddress.lastName,
        company: this.state.choosedShipAddress.company,
        address: this.state.choosedShipAddress.address,
        city: this.state.choosedShipAddress.city,
        state: this.state.choosedShipAddress.region,
        zip: this.state.choosedShipAddress.postCode,
        country: this.state.choosedShipAddress.country,
      },
    };

    const res = await this.props.payWithAffirm(data);

    if (res.status === 200) {
      this.setState({
        addressClass: "disabled done",
        cardClass: "disabled done",
        successClass: "current done",
        addressClassShow: "hide",
        cardClassShow: "hide",
        successClassShow: "show",
        total: 0,
        easypostTex: 0,
        shipment: 0,
        rewardPoints: 0,
      });
      localStorage.setItem("affirm", JSON.stringify([]));
      localStorage.setItem("cart", JSON.stringify([]));
      localStorage.setItem("coupon", JSON.stringify([]));
      localStorage.setItem("shipment", JSON.stringify([]));
    }
  };
  _easypost = async () => {
    const res = await this.props.getCart();
    var location = localStorage.getItem("location");

    res &&
      res.forEach((element) => {
        var brandId = element.item.brand;
        var productinfo = element.item;
        this.setState({
          location: JSON.parse(location),
          brandId: brandId,
          productInfo: productinfo,
        });
        // if (element.item.price < 49) {
        this._validateEasypost();
        // }
      });
  };
  _validateEasypost = async () => {
    const { location, brandId, productInfo } = this.state;

    const formData = {
      location: location,
      brandId: brandId,
      productInfo: productInfo,
    };

    const res = await this.props.validateEasypost(formData);

    if (res) {
      var obj = { 0: res, 1: [productInfo._id] };
      this.setState({
        easypostObjs: this.state.easypostObjs.concat([obj]),
      });
    } else if (res && res.status === false) {
      this.setState({ texjarMessage: false });
    }
    setTimeout(() => {
      this.setState({ texjarMessage: null });
    }, 3000);
  };
  cardInfo = () => {
    if (this.state.choosedBillAddress && this.state.choosedShipAddress) {
      this.setState({
        addressClass: "disabled done",
        addressClassShow: "hide",
        deliveryClassShow: "show",
        deliveryClass: "current",
      });
    } else {
      toast.error(`Please Select Address`, { containerId: "B" });
    }
  };
  deliveryInfo = () => {
    this.setState({
      addressClass: "disabled done",
      addressClassShow: "hide",
      deliveryClassShow: "hide",
      deliveryClass: "disabled done",
      cardClass: "current",
      cardClassShow: "show",
    });
  };
  _addToShipping = async (product_id, epost, selectedShipping) => {
    const data = {
      epost: epost,
      selectedShipping: selectedShipping,
      product_id: product_id,
    };
    const cartAdd = await this.props.shipmentAdd(data);
  };
  render() {
    const { cart, shipment, easypostObjs, total, rewardPoints } = this.state;

    return (
      <Fragment>
        <ToastContainer
          enableMultiContainer
          containerId={"B"}
          position={toast.POSITION.TOP_RIGHT}
        />
        <header className="checkout-header">
          <div className="checkout-header-content checkout-wrapper wrapper-90 max-1600 d-block">
            <div className="d-flex justify-content-between align-items-center w-100">
              <div className="checkout-header-right">
                <div className="steps clearfix">
                  <ul
                    role="tablist"
                    className="d-flex align-items-center checkout-steps-links-list"
                  >
                    <li>
                      <h1 className="checkout-title mb-0">Checkout</h1>
                    </li>
                    <li className="d-flex d-flex-990">
                      <li
                        role="tab"
                        className={`first ${
                          this.state.addressClass && this.state.addressClass
                        }`}
                        aria-disabled="false"
                        aria-selected="true"
                      >
                        <a
                          id="signup-form-t-0"
                          href="#signup-form-h-0"
                          aria-controls="signup-form-p-0"
                        >
                          <span className="current-info audible"> </span>
                          <div className="title">
                            <span className="number">1</span>
                            <span className="font-small">Shipping Address</span>
                          </div>
                        </a>
                      </li>
                      <li
                        role="tab"
                        className={` ${
                          this.state.deliveryClass && this.state.deliveryClass
                        }`}
                        aria-disabled="true"
                      >
                        <a
                          id="signup-form-t-1"
                          href="#signup-form-h-1"
                          aria-controls="signup-form-p-1"
                        >
                          <div className="title">
                            <span className="number">2</span>
                            <span className="font-small">Delivery Method</span>
                          </div>
                        </a>
                      </li>
                      <li
                        role="tab"
                        className={`${
                          this.state.successClass && this.state.successClass
                        }`}
                        aria-disabled="true"
                      >
                        <a
                          id="signup-form-t-2"
                          href="#signup-form-h-2"
                          aria-controls="signup-form-p-2"
                        >
                          <div className="title">
                            <span className="number">3</span>
                            <span className="font-small">Payment Details</span>
                          </div>
                        </a>
                      </li>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="d-flex align-items-center checkout-header-left">
                <span>
                  <svg className="checkoutCart-icon" viewBox="0 0 28 28">
                    <path d="M20 10h-2a4 4 0 1 0-8 0H8a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V11a1 1 0 0 0-1-1zm-6-2a2 2 0 0 1 2 2h-4a2 2 0 0 1 2-2zm5 12H9v-8h10v8z"></path>
                    <path d="M14 13.5a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1z"></path>
                  </svg>
                  &nbsp;
                </span>
                <span className="d-none-480">Secure Checkout</span>
                <Link to={"/shopping-cart"} title="Back to Cart">
                  <svg className="checkoutCart-icon" viewBox="0 0 28 28">
                    <path d="M20.86 18.14H10.19l.91-1.31h9.76a1 1 0 0 0 1-.83L23 9.38a1 1 0 0 0-.23-.81 1 1 0 0 0-.77-.36H9.63l-.38-1.46a1 1 0 0 0-1-.75H6a1 1 0 1 0 0 2h1.51l2 7.64-2 2.93a1 1 0 0 0-.06 1 1 1 0 0 0 .89.53h.46a1.38 1.38 0 1 0 2.4 0h6.74a1.47 1.47 0 0 0-.17.66 1.38 1.38 0 1 0 2.57-.66h.52a1 1 0 1 0 0-2v.04zm-.05-7.93L20 14.83h-8.65l-1.2-4.62h10.66z"></path>
                  </svg>
                  &nbsp;
                </Link>
                <Link to={"/shopping-cart"} id="backTO-cart-txt">
                  Back to Cart
                </Link>
              </div>
            </div>
            <div className="d-none-990">
              <div className="steps clearfix mt-4">
                <ul
                  role="tablist"
                  className="d-flex align-items-center checkout-steps-links-list"
                >
                  <li
                    role="tab"
                    className={`first ${
                      this.state.addressClass && this.state.addressClass
                    }`}
                    aria-disabled="false"
                    aria-selected="true"
                  >
                    <a
                      id="signup-form-t-0"
                      href="#signup-form-h-0"
                      aria-controls="signup-form-p-0"
                    >
                      <span className="current-info audible"> </span>
                      <div className="title">
                        <span className="number">1</span>
                        <span className="font-small">Shipping Address</span>
                      </div>
                    </a>
                  </li>
                  <li
                    role="tab"
                    className={` ${
                      this.state.deliveryClass && this.state.deliveryClass
                    }`}
                    aria-disabled="true"
                  >
                    <a
                      id="signup-form-t-1"
                      href="#signup-form-h-1"
                      aria-controls="signup-form-p-1"
                    >
                      <div className="title">
                        <span className="number">2</span>
                        <span className="font-small">Delivery Method</span>
                      </div>
                    </a>
                  </li>
                  <li
                    role="tab"
                    className={`${
                      this.state.successClass && this.state.successClass
                    }`}
                    aria-disabled="true"
                  >
                    <a
                      id="signup-form-t-2"
                      href="#signup-form-h-2"
                      aria-controls="signup-form-p-2"
                    >
                      <div className="title">
                        <span className="number">3</span>
                        <span className="font-small">Payment Details</span>
                      </div>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </header>
        <div
          className="checkout-wrapper wrapper-90 max-1600"
          ref={(el) => (this.instance = el)}
        >
          {/*  <BreadCrumb title={`Checkout`} /> */}
          <main className="checkout-main">
            <div className="container-fluid px-0">
              <div className="row">
                <div className="col-md-8">
                  <div className="checkout-main-left">
                    <div className="form-wizard">
                      <div className="container-fluid myacc-body px-0">
                        <fieldset
                          className={`container-wizard ${
                            this.state.addressClassShow &&
                            this.state.addressClassShow
                          }`}
                        >
                          <div className="fieldset-content">
                            <div className="checkout-title-header">
                              <h3 className="shipping-add-title">
                                Shipping Address
                              </h3>
                            </div>
                            <div className="shipping-add-content">
                              {this.state.address &&
                                this.state.address.map((item, index) => (
                                  <label
                                    key={index}
                                    className={`address-label ${
                                      index === 0 ? "selected" : ""
                                    }`}
                                    style={{ display: "block" }}
                                    sort={1}
                                  >
                                    <div className="changeShipping-add">
                                      <input
                                        type="radio"
                                        name="choosedShipAddress"
                                        className="checkbox-checkout"
                                        value={item}
                                        onChange={() => {
                                          this.setState({
                                            choosedShipAddress: item,
                                            choosedBillAddress: item,
                                          });
                                        }}
                                      />
                                      <div className="shipping-add-inner">
                                        <p className="shipping-name-city">
                                          <span className="shipping-name">
                                            {item.firstName +
                                              " " +
                                              item.lastName}
                                          </span>
                                          &nbsp; |&nbsp;
                                          <span className="shipping-city">
                                            {item.city}
                                          </span>
                                        </p>
                                        <p className="shipping-short-address">
                                          {item.company +
                                            " " +
                                            item.address +
                                            " " +
                                            item.postCode +
                                            " " +
                                            item.region}
                                        </p>
                                        <p className="shipping-ph-number"></p>
                                        <p className="change-shipping-add">
                                          <Link
                                            to={`/edit-address-book/${item._id}`}
                                            style={{ color: "#17a2b8" }}
                                          >
                                            <span>Edit</span>
                                          </Link>
                                        </p>
                                        <div className="continue-edit-add">
                                          <button className="add-continue-btn">
                                            Continue
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </label>
                                ))}
                              <hr />
                              <div className="add-new-add py-2">
                                <Link
                                  to="/add-new-address-book"
                                  onClick={() => {
                                    this.props.history.push(
                                      "/add-new-address-book"
                                    );
                                  }}
                                  className="add-new-add-btn"
                                >
                                  <span>Add New Address</span>
                                </Link>
                              </div>
                            </div>
                          </div>
                          <div className="fieldset-footer">
                            <span>Step 1 of 3</span>
                            <div className="actions clearfix">
                              <ul role="menu" aria-label="Pagination">
                                <li aria-disabled="false">
                                  <a
                                    href="#previous"
                                    style={{ display: "none" }}
                                    role="menuitem"
                                  >
                                    Previous
                                  </a>
                                </li>
                                <li aria-hidden="false" aria-disabled="false">
                                  <a
                                    href="#next"
                                    role="menuitem"
                                    onClick={this.cardInfo}
                                  >
                                    Next
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </fieldset>
                        <fieldset
                          className={`container-wizard ${
                            this.state.deliveryClassShow &&
                            this.state.deliveryClassShow
                          }`}
                        >
                          <div className="fieldset-content">
                            <div className="checkout-title-header">
                              <h3 className="shipping-add-title">
                                Delivery Method
                              </h3>
                            </div>
                            <div className="shipping-add-content">
                              {cart &&
                                cart.length > 0 &&
                                cart.map((item, index) =>
                                  item.color && item.color ? (
                                    <div
                                      key={index}
                                      className="delivery-method-content"
                                    >
                                      {item.item.attribute &&
                                        item.item.attribute.map(
                                          (attrib, indx) =>
                                            item.color ===
                                            JSON.parse(attrib).color ? (
                                              <Fragment key={indx}>
                                                <div className="dm-date-img">
                                                  <div className="dm-img">
                                                    <img
                                                      src={
                                                        item.item.images[
                                                          JSON.parse(attrib)
                                                            .image
                                                        ]
                                                      }
                                                      width="100%"
                                                      alt=""
                                                    />
                                                  </div>
                                                  <div className="dm-date">
                                                    <span className="git-d">
                                                      <Link
                                                        className="text-color delivery-method-links"
                                                        to={`/product/${item.item.slug}`}
                                                      >
                                                        {item &&
                                                          item.item.title}
                                                      </Link>
                                                    </span>
                                                    <span className="git-m">
                                                      Model:{" "}
                                                      {item && item.item.model}
                                                    </span>
                                                    <span className="git-m">
                                                      Color:{" "}
                                                      {JSON.parse(attrib).color}
                                                    </span>
                                                    <div className="git-m myCart-rating">
                                                      <ul className="myCart-rating-list">
                                                        <StarRatings
                                                          rating={
                                                            item.item &&
                                                            item.item.reviews
                                                              ? item.item
                                                                  .reviews /
                                                                item.item
                                                                  .reviewCount
                                                              : 0
                                                          }
                                                          starDimension="20px"
                                                          starSpacing="2px"
                                                          starRatedColor="gold"
                                                        />
                                                        <span>
                                                          {item.item &&
                                                            item.item
                                                              .reviewCount}
                                                        </span>
                                                      </ul>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div
                                                  className="select-dm-method"
                                                  style={{
                                                    display: "block",
                                                    padding: "0px 100px",
                                                  }}
                                                >
                                                  <span>
                                                    {easypostObjs &&
                                                    total < 49 ? (
                                                      <label className="radio-inline sub-yes-no">
                                                        <input
                                                          type="radio"
                                                          name={`${item.item.slug}`}
                                                          id="yesNews"
                                                          onChange={() => {
                                                            this._addToShipping(
                                                              item.item._id,
                                                              {},
                                                              { rate: 0 }
                                                            );
                                                          }}
                                                        />
                                                        <span className="create-acc-placeholder">
                                                          <span>
                                                            &nbsp; Get it by{" "}
                                                            {moment()
                                                              .add(10, "days")
                                                              .format(
                                                                "ddd D MMM, YYYY"
                                                              )}{" "}
                                                            - Ground
                                                          </span>
                                                        </span>
                                                      </label>
                                                    ) : (
                                                      <label className="radio-inline sub-yes-no">
                                                        <input
                                                          type="radio"
                                                          name={`${item.item.slug}`}
                                                          id="yesNews"
                                                          onChange={() => {
                                                            this._addToShipping(
                                                              item.item._id,
                                                              {},
                                                              { rate: 0 }
                                                            );
                                                          }}
                                                        />
                                                        <span className="create-acc-placeholder">
                                                          <span>
                                                            &nbsp; Get it by{" "}
                                                            {moment()
                                                              .add(10, "days")
                                                              .format(
                                                                "ddd D MMM, YYYY"
                                                              )}{" "}
                                                            - Ground
                                                          </span>
                                                        </span>
                                                      </label>
                                                    )}
                                                    {easypostObjs &&
                                                      easypostObjs.map(
                                                        (itm, index) => {
                                                          if (
                                                            itm[1][0] ===
                                                            item.item._id
                                                          ) {
                                                            return itm[0].rates
                                                              .length !== 0 ? (
                                                              <span key={index}>
                                                                {" "}
                                                                {itm[0] &&
                                                                  itm[0].rates.map(
                                                                    (
                                                                      easy,
                                                                      index1
                                                                    ) =>
                                                                      item.delivery_days !==
                                                                      null ? (
                                                                        <label
                                                                          key={
                                                                            index1
                                                                          }
                                                                          className="radio-inline sub-yes-no"
                                                                        >
                                                                          <input
                                                                            type="radio"
                                                                            name={`${item.item.slug}`}
                                                                            id="yesNews"
                                                                            onChange={() => {
                                                                              this._addToShipping(
                                                                                itm[1][0],
                                                                                itm[0],
                                                                                easy
                                                                              );
                                                                            }}
                                                                          />
                                                                          <span className="create-acc-placeholder">
                                                                            <span>
                                                                              &nbsp;
                                                                              Get
                                                                              it
                                                                              by{" "}
                                                                              {moment()
                                                                                .add(
                                                                                  easy.delivery_days,
                                                                                  "days"
                                                                                )
                                                                                .format(
                                                                                  "ddd D MMM, YYYY"
                                                                                )}{" "}
                                                                              -{" "}
                                                                              {
                                                                                easy.carrier
                                                                              }
                                                                            </span>
                                                                          </span>
                                                                        </label>
                                                                      ) : null
                                                                  )}
                                                              </span>
                                                            ) : (
                                                              <span key={index}>
                                                                Shipping Not
                                                                Available In
                                                                your Area
                                                              </span>
                                                            );
                                                          }
                                                        }
                                                      )}
                                                  </span>
                                                </div>
                                              </Fragment>
                                            ) : (
                                              <span></span>
                                            )
                                        )}
                                    </div>
                                  ) : (
                                    <div
                                      key={index}
                                      className="delivery-method-content"
                                    >
                                      <div className="dm-date-img">
                                        <div className="dm-img">
                                          <img
                                            src={item.item.mainImage}
                                            width="100%"
                                            alt=""
                                          />
                                        </div>
                                        <div className="dm-date">
                                          <span className="git-d">
                                            <Link
                                              to={`/product/${item.item.slug}`}
                                            >
                                              {item && item.item.title}
                                            </Link>
                                          </span>
                                          <span className="git-m">
                                            {item.item.model}
                                          </span>
                                          <div className="git-m myCart-rating">
                                            <ul className="myCart-rating-list">
                                              <StarRatings
                                                rating={
                                                  item.item && item.item.reviews
                                                    ? item.item.reviews /
                                                      item.item.reviewCount
                                                    : 0
                                                }
                                                starDimension="20px"
                                                starSpacing="2px"
                                                starRatedColor="gold"
                                              />
                                              <span>
                                                {item.item &&
                                                  item.item.reviewCount}
                                              </span>
                                            </ul>
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        className="select-dm-method"
                                        style={{
                                          display: "block",
                                          padding: "0px 100px",
                                        }}
                                      >
                                        <span>
                                          {easypostObjs && total < 49 ? (
                                            <label className="radio-inline sub-yes-no">
                                              <input
                                                type="radio"
                                                name={`${item.item.slug}`}
                                                id="yesNews"
                                                onChange={() => {
                                                  this._addToShipping(
                                                    item.item._id,
                                                    {},
                                                    { rate: 0 }
                                                  );
                                                }}
                                              />
                                              <span className="create-acc-placeholder">
                                                <span>
                                                  &nbsp; Get it by{" "}
                                                  {moment()
                                                    .add(10, "days")
                                                    .format(
                                                      "ddd D MMM, YYYY"
                                                    )}{" "}
                                                  - Ground
                                                </span>
                                              </span>
                                            </label>
                                          ) : (
                                            <label className="radio-inline sub-yes-no">
                                              <input
                                                type="radio"
                                                name={`${item.item.slug}`}
                                                id="yesNews"
                                                onChange={() => {
                                                  this._addToShipping(
                                                    item.item._id,
                                                    {},
                                                    { rate: 0 }
                                                  );
                                                }}
                                              />
                                              <span className="create-acc-placeholder">
                                                <span>
                                                  &nbsp; Get it by{" "}
                                                  {moment()
                                                    .add(10, "days")
                                                    .format(
                                                      "ddd D MMM, YYYY"
                                                    )}{" "}
                                                  - Ground
                                                </span>
                                              </span>
                                            </label>
                                          )}
                                          {easypostObjs &&
                                            easypostObjs.map((itm, index) => {
                                              if (itm[1][0] === item.item._id) {
                                                return itm[0].rates.length !==
                                                  0 ? (
                                                  <span key={index}>
                                                    {" "}
                                                    {itm[0] &&
                                                      itm[0].rates.map(
                                                        (easy, index1) =>
                                                          item.delivery_days !==
                                                          null ? (
                                                            <label
                                                              key={index1}
                                                              className="radio-inline sub-yes-no"
                                                            >
                                                              <input
                                                                type="radio"
                                                                name={`${item.item.slug}`}
                                                                id="yesNews"
                                                                onChange={() => {
                                                                  this._addToShipping(
                                                                    itm[1][0],
                                                                    itm[0],
                                                                    easy
                                                                  );
                                                                }}
                                                              />
                                                              <span className="create-acc-placeholder">
                                                                <span>
                                                                  &nbsp; Get it
                                                                  by{" "}
                                                                  {moment()
                                                                    .add(
                                                                      easy.delivery_days,
                                                                      "days"
                                                                    )
                                                                    .format(
                                                                      "ddd D MMM, YYYY"
                                                                    )}{" "}
                                                                  -{" "}
                                                                  {easy.carrier}
                                                                </span>
                                                              </span>
                                                            </label>
                                                          ) : null
                                                      )}
                                                  </span>
                                                ) : (
                                                  <span key={index}>
                                                    Shipping Not Available In
                                                    your Area
                                                  </span>
                                                );
                                              }
                                            })}
                                        </span>
                                      </div>
                                    </div>
                                  )
                                )}

                              <hr />
                            </div>
                          </div>
                          <div className="fieldset-footer">
                            <span>Step 1 of 3</span>
                            <div className="actions clearfix">
                              <ul role="menu" aria-label="Pagination">
                                <li aria-disabled="false">
                                  <a
                                    href="#previous"
                                    style={{ display: "none" }}
                                    role="menuitem"
                                  >
                                    Previous
                                  </a>
                                </li>
                                <li aria-hidden="false" aria-disabled="false">
                                  <a
                                    href="#next"
                                    role="menuitem"
                                    onClick={this.deliveryInfo}
                                  >
                                    Next
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </fieldset>
                        <fieldset
                          className={`container-wizard px-4 ${
                            this.state.cardClassShow && this.state.cardClassShow
                          }`}
                        >
                          <div className="fieldset-content">
                            <label className="payment-input-field">
                              <span className="payment-inp-placeholder payment-inp-placeholder1">
                                Payment Type:
                              </span>
                              <ul className="nav nav-tabs" role="tablist">
                                <li className="nav-item">
                                  <a
                                    className="nav-link active show"
                                    id="visaCard-tab"
                                    data-toggle="tab"
                                    href="#visaCard"
                                    role="tab"
                                    aria-controls="visaCard"
                                    aria-selected="true"
                                  >
                                    <img
                                      src="https://sundialinsider.s3.us-east-2.amazonaws.com/376icon-cards.jpg"
                                      title="Visa Card"
                                      alt="Visa Card"
                                      width="90px"
                                    />
                                  </a>
                                </li>
                                <li className="nav-item">
                                  <a
                                    className="nav-link"
                                    id="masterCard-tab"
                                    data-toggle="tab"
                                    href="#masterCard"
                                    role="tab"
                                    aria-controls="masterCard"
                                    aria-selected="false"
                                    onClick={this.payWithAffirm}
                                  >
                                    <img
                                      src="https://cdn-assets.affirm.com/images/black_logo-transparent_bg.png"
                                      title="Master Card"
                                      alt="Master Card"
                                      width="60px"
                                    />
                                  </a>
                                </li>
                              </ul>
                            </label>
                            <div className="tab-content" id="myTabContent">
                              <Alert />
                              <div
                                className="tab-pane fade active show"
                                id="visaCard"
                                role="tabpanel"
                                aria-labelledby="visaCard-tab"
                              >
                                <div className="payment-month-cvc">
                                  <label
                                    htmlFor="name-on-card"
                                    className="payment-input-field"
                                  >
                                    <span className="payment-inp-placeholder payment-inp-placeholder1">
                                      Name on Card
                                    </span>
                                    <input
                                      type="text"
                                      className="payment-input payment-input1"
                                      name="cardholder-name"
                                      onChange={(e) => {
                                        this.setState({
                                          cardholderName: e.target.value,
                                        });
                                      }}
                                    />
                                  </label>
                                  <label
                                    htmlFor="card-number"
                                    className="payment-input-field"
                                  >
                                    <span className="payment-inp-placeholder payment-inp-placeholder1">
                                      Card Number
                                    </span>
                                    <input
                                      type="number"
                                      name="card-number"
                                      maxLength={16}
                                      onInput={(e) => {
                                        e.target.value = Math.max(
                                          0,
                                          parseInt(e.target.value)
                                        )
                                          .toString()
                                          .slice(0, 16);
                                      }}
                                      className="payment-input payment-input1"
                                      onChange={(e) => {
                                        this.setState({
                                          cardNumber: e.target.value,
                                        });
                                      }}
                                    />
                                  </label>
                                </div>
                                <div className="payment-month-cvc">
                                  <label
                                    htmlFor="exp-date"
                                    className="payment-input-field"
                                  >
                                    <span className="payment-inp-placeholder payment-inp-placeholder1">
                                      Exp. Date
                                    </span>
                                    <div className="checkout-zipState-inps">
                                      <label htmlFor="statezip" id="state-zip">
                                        <select
                                          className="stateSelect width-49"
                                          name="months"
                                          defaultValue={this.state.exp}
                                          onChange={(e) => {
                                            this.setState({
                                              exp: e.target.value,
                                            });
                                          }}
                                        >
                                          <option disabled>MM</option>
                                          <option value={"01"}>January</option>
                                          <option value={"02"}>
                                            February{" "}
                                          </option>
                                          <option value={"03"}>March</option>
                                          <option value={"04"}>April</option>
                                          <option value={"05"}>May</option>
                                          <option value={"06"}>June</option>
                                          <option value={"07"}>July</option>
                                          <option value={"08"}>August</option>
                                          <option value={"09"}>
                                            September
                                          </option>
                                          <option value={"10"}>October</option>
                                          <option value={"11"}>November</option>
                                          <option value={"12"}>December</option>
                                        </select>
                                        <select
                                          className="stateSelect width-49"
                                          onChange={(e) => {
                                            this.setState({
                                              year: e.target.value,
                                            });
                                          }}
                                          defaultValue={this.state.year}
                                        >
                                          <option disabled>YY</option>
                                          <option value={"20"}>2020</option>
                                          <option value={"21"}>2021</option>
                                          <option value={"22"}>2022</option>
                                          <option value={"23"}>2023</option>
                                          <option value={"24"}>2024</option>
                                          <option value={"25"}>2025</option>
                                          <option value={"26"}>2026</option>
                                          <option value={"27"}>2027</option>
                                          <option value={"28"}>2028</option>
                                        </select>
                                      </label>
                                    </div>
                                  </label>
                                  <label
                                    htmlFor="cvc"
                                    className="payment-input-field"
                                  >
                                    <span className="payment-inp-placeholder payment-inp-placeholder1">
                                      CVC
                                    </span>
                                    <input
                                      type="number"
                                      maxLength={3}
                                      onInput={(e) => {
                                        e.target.value = Math.max(
                                          0,
                                          parseInt(e.target.value)
                                        )
                                          .toString()
                                          .slice(0, 3);
                                      }}
                                      className="payment-input payment-input1"
                                      onChange={(e) => {
                                        this.setState({
                                          cvc: e.target.value,
                                        });
                                      }}
                                      name="cvc"
                                    />
                                  </label>
                                </div>
                              </div>
                              <div
                                className="tab-pane fade text-center"
                                id="masterCard"
                                role="tabpanel"
                                aria-labelledby="masterCard-tab"
                              >
                                <img
                                  src="https://cdn-assets.affirm.com/images/buttons/checkout/42x205-blue.svg"
                                  title="affirm checkout"
                                  alt="affirm checkout"
                                  id="submit-form"
                                  style={{ cursor: "pointer" }}
                                />
                              </div>
                            </div>{" "}
                          </div>
                          <div className="fieldset-footer">
                            <span>Step 2 of 3</span>
                            <div className="actions clearfix">
                              <ul role="menu" aria-label="Pagination">
                                <li aria-disabled="false">
                                  <a
                                    href="#previous"
                                    style={{ display: "none" }}
                                    role="menuitem"
                                  >
                                    Previous
                                  </a>
                                </li>
                                <li aria-hidden="false" aria-disabled="false">
                                  <a
                                    href="#next"
                                    role="menuitem"
                                    onClick={this.payNow}
                                  >
                                    Next
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </fieldset>
                        <fieldset
                          className={`container-wizard p-4 ${
                            this.state.successClassShow &&
                            this.state.successClassShow
                          } text-center`}
                        >
                          <div className="fieldset-content text-center">
                            <section className="delivery-method-section ">
                              <div className="delivery-method-header">
                                <h3 className="delivery-method-title">
                                  Thank you
                                </h3>
                              </div>
                              <div className="delivery-method-content">
                                Thank You For Your Order ...!
                              </div>
                              <hr />
                            </section>
                          </div>
                          <div className="fieldset-footer"></div>
                        </fieldset>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="checkout-main-right">
                    <div className="checkout-stick-popup">
                      <div className="checkoutPopup-content">
                        <div className="checkoutCart-summary">
                          <div
                            className="card"
                            style={{
                              border: "none",
                              backgroundColor: "transparent",
                            }}
                          >
                            <div id="headingOne" className="summary-heading">
                              <span />
                              <div className="cartSummary-item">
                                <strong>Cart Summary</strong>
                                <br />
                                <span>items {cart.length && cart.length}</span>
                              </div>
                              <div
                                className={
                                  this.state.cartSummary
                                    ? "h-fit-content borderAdd"
                                    : "no-brder"
                                }
                              >
                                <a
                                  className=" p-1 product1-shipto-code"
                                  href="#"
                                  onClick={this.handleSummary}
                                >
                                  {this.state.cartSummary
                                    ? "Collapse"
                                    : "Expand"}
                                  &nbsp; <i className="fa fa-angle-down" />
                                </a>
                              </div>
                            </div>

                            <div
                              className={
                                this.state.cartSummary
                                  ? "collapse"
                                  : "small-sammry-img"
                              }
                            >
                              {cart &&
                                cart.length > 0 &&
                                cart.map((item, index) =>
                                  item.color && item.color ? (
                                    item.item.attribute.map((attrib, indx) =>
                                      JSON.parse(attrib).color ===
                                      item.color ? (
                                        <div className="cartSummary-imgs-list">
                                          <img
                                            key={index}
                                            src={
                                              item.item &&
                                              item.item.images &&
                                              item.item.images[
                                                JSON.parse(attrib).image
                                              ]
                                            }
                                            width="100%"
                                            alt=""
                                          />{" "}
                                        </div>
                                      ) : null
                                    )
                                  ) : (
                                    <div className="cartSummary-imgs-list">
                                      <img
                                        key={index}
                                        src={
                                          item.item &&
                                          item.item &&
                                          item.item.mainImage
                                        }
                                        width="100%"
                                        alt=""
                                      />
                                    </div>
                                  )
                                )}
                            </div>

                            <div
                              id="checkout-summry-item"
                              className={
                                this.state.cartSummary ? "show" : "collapse"
                              }
                            >
                              {" "}
                              {cart &&
                                cart.length > 0 &&
                                cart.map((item, index) =>
                                  item.color && item.color ? (
                                    <div key={index} className="card-body pl-0">
                                      {item.item.attribute &&
                                        item.item.attribute.map(
                                          (attrib, indx) =>
                                            JSON.parse(attrib).color ===
                                            item.color ? (
                                              <div className="summary-item-body sm-flex-wrap">
                                                <div className="summary-img">
                                                  <img
                                                    src={
                                                      item.item.images[
                                                        JSON.parse(attrib).image
                                                      ]
                                                    }
                                                    width="120px"
                                                    alt={
                                                      item && item.item.title
                                                    }
                                                  />
                                                </div>
                                                <div className="summary-details">
                                                  <span>
                                                    {item.item.title !==
                                                      "undefined" &&
                                                      item.item.title}
                                                  </span>
                                                </div>
                                                <div className="summary-price">
                                                  <span>
                                                    $
                                                    {JSON.parse(attrib).price *
                                                      item.quantity}
                                                  </span>
                                                </div>
                                                <div
                                                  className="summary-remove-option"
                                                  onClick={() => {
                                                    this.removeCartItem(index);
                                                  }}
                                                >
                                                  <i className="fas fa-trash-alt" />
                                                  &nbsp;
                                                  <span>Remove</span>
                                                </div>
                                              </div>
                                            ) : null
                                        )}
                                    </div>
                                  ) : (
                                    <div key={index} className="card-body pl-0">
                                      <div className="summary-item-body">
                                        <div className="cartSummary-imgs-list summary-img">
                                          <img
                                            src={item.item.mainImage}
                                            width="120px"
                                            alt={item && item.item.title}
                                          />
                                        </div>
                                        <div className="summary-details">
                                          <span>
                                            {item.item.title !== "undefined" &&
                                              item.item.title}
                                          </span>
                                        </div>
                                        <div className="summary-price">
                                          <span>
                                            ${item.item.price * item.quantity}
                                          </span>
                                        </div>
                                        <div
                                          className="summary-remove-option"
                                          onClick={() => {
                                            this.removeCartItem(index);
                                          }}
                                        >
                                          <i className="fas fa-trash-alt" />
                                          &nbsp;
                                          <span>Remove</span>
                                        </div>
                                      </div>
                                    </div>
                                  )
                                )}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div className="checkout-sub-total">
                          <span>Item Subtotal:</span>
                          <span>
                            $
                            {this.state.total &&
                              Number(this.state.total).toFixed(2)}
                          </span>
                        </div>

                        <div className="checkout-shipping">
                          <span>Shipping:</span>
                          <span>
                            {this.state.shipment === 0
                              ? this.state.total < 49
                                ? "$" + Number(4.99).toFixed(2)
                                : "Free"
                              : "$" + Number(this.state.shipment).toFixed(2)}
                          </span>
                        </div>

                        <div className="checkout-shipping">
                          <span>Coupon:</span>
                          <span>
                            $
                            {this.state.couponObject
                              ? Number(
                                  (this.state.couponObject.coupon
                                    .pricePercentage /
                                    100) *
                                    this.state.total
                                ).toFixed(2)
                              : 0}
                          </span>
                        </div>

                        <div className="myCart-tax my-3">
                          <span className="tax">Tax:</span>
                          <span>
                            $
                            {this.state.texjarSales &&
                              Number(
                                (this.state.texjarSales / 100) *
                                  this.state.total
                              ).toFixed(2)}
                          </span>
                        </div>
                        {rewardPoints &&
                        rewardPoints !== 0 &&
                        rewardPoints < total ? (
                          <div className="checkout-shipping">
                            <span>Reward Points:</span>
                            <span>
                              {"- $" + Number(rewardPoints).toFixed(2)}
                            </span>
                          </div>
                        ) : null}
                        <div className="checkout-total">
                          <div className="checkout-total-content">
                            <strong>Total:</strong>
                            <strong>
                              $
                              {rewardPoints &&
                              rewardPoints !== 0 &&
                              rewardPoints < total
                                ? this.state.total && this.state.couponObject
                                  ? Number(
                                      shipment +
                                        Number(this.state.total) -
                                        (this.state.couponObject.coupon
                                          .pricePercentage /
                                          100) *
                                          Number(this.state.total) +
                                        (this.state.texjarSales / 100) *
                                          this.state.total -
                                        rewardPoints
                                    ).toFixed(2)
                                  : Number(
                                      shipment +
                                        Number(this.state.total) +
                                        (this.state.texjarSales / 100) *
                                          this.state.total -
                                        rewardPoints
                                    ).toFixed(2)
                                : this.state.total && this.state.couponObject
                                ? Number(
                                    shipment +
                                      Number(this.state.total) -
                                      (this.state.couponObject.coupon
                                        .pricePercentage /
                                        100) *
                                        Number(this.state.total) +
                                      (this.state.texjarSales / 100) *
                                        this.state.total
                                  ).toFixed(2)
                                : Number(
                                    shipment +
                                      Number(this.state.total) +
                                      (this.state.texjarSales / 100) *
                                        this.state.total
                                  ).toFixed(2)}
                            </strong>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </Fragment>
    );
  }
}

payNow.propTypes = {
  payNow: PropTypes.func.isRequired,
};

getCart.propTypes = {
  getCart: PropTypes.func.isRequired,
};
getShipment.propTypes = {
  getShipment: PropTypes.func.isRequired,
};

validateCoupon.propTypes = {
  validateCoupon: PropTypes.func.isRequired,
};

auth.propsTypes = {
  auth: PropTypes.func.isRequired,
};

getAddressBook.propTypes = {
  getAddressBook: PropTypes.func.isRequired,
};
payWithAffirm.propTypes = {
  payWithAffirm: PropTypes.func.isRequired,
};
validateEasypost.propTypes = {
  validateEasypost: PropTypes.func.isRequired,
};
shipmentAdd.propTypes = {
  shipmentAdd: PropTypes.func.isRequired,
};
const mapStateToProps = (state) => ({
  _auth: state.auth,
});

export default connect(mapStateToProps, {
  payNow,
  getCart,
  validateCoupon,
  auth,
  getAddressBook,
  getShipment,
  payWithAffirm,
  validateEasypost,
  shipmentAdd,
})(Checkout);
